import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { BaseComponent } from '../../../components/BaseComponent';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import LoadingField from '../../../containers/App/Components/LoadingField/LoadingField';
import { deleteVehicleProperty, fetchVehicle, setVehicleProperty, switchVehicleRdwDates } from '../../Vehicles/actions';
import { selectWork, selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE, SWITCH_VEHICLE_RDW_DATES } from '../../Vehicles/constants';
import { getPropByName } from '../../../utils/props';
import { selectVehicle } from '../../Vehicles/selectors';
import { VBox } from '../../../components/Box';
import { Cell, List, Row } from '../../../components/List';

const STATE = {
  switchRdwDates: false,
  rdw_tenaamstelling_date_seller_sold: null,
};

/* eslint-disable react/prefer-stateless-function */
class RdwDateSellerSoldButtonComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.swithRdwDates(this.props.vehicleId, result => {
      if (result) {
        this.setState({ switchRdwDates: true });
      }
    });
    this.props.fetch(this.props.vehicleId, result => {
      const rdw_tenaamstelling_date_seller_sold = getPropByName(result, 'rdw_tenaamstelling_date_seller_sold');

      if (rdw_tenaamstelling_date_seller_sold) {
        this.setState({ rdw_tenaamstelling_date_seller_sold: rdw_tenaamstelling_date_seller_sold });
      }
    });
  }

  onSwitchRdwDates() {
    this.props.setProperty(
      this.props.vehicleId,
      'rdw_tenaamstelling_date_seller',
      this.state.rdw_tenaamstelling_date_seller_sold,
    );
    this.props.deleteProperty(this.props.vehicleId, 'rdw_tenaamstelling_date_seller_sold');
  }

  render() {
    if (this.props.work) return <LoadingField />;
    return (
      <VBox>
        <ButtonComponent
          disabled={!this.state.switchRdwDates}
          style={'ButtonSoftPrimaryFullWidth'}
          onClick={() => this.onSwitchRdwDates()}
        >
          Reset rdw_tenaamstelling_date_seller_sold
        </ButtonComponent>
        <List>
          <Row>
            <Cell>{this.lbl('vehicle.property.rdw_tenaamstelling_date_seller')}</Cell>
            <Cell>{this.props.vehicle?.rdw_tenaamstelling_date_seller}</Cell>
          </Row>
        </List>
      </VBox>
    );
  }
}

RdwDateSellerSoldButtonComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE, SWITCH_VEHICLE_RDW_DATES]),
    vehicle: selectVehicle(ownProps.vehicleId),
  });

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    swithRdwDates(vehicleId, callback) {
      dispatch(switchVehicleRdwDates(vehicleId, callback));
    },
    fetch(vehicleId, callback) {
      dispatch(fetchVehicle(vehicleId, callback));
    },
    setProperty(vehicleId, propertyName, propertyValue, callback) {
      dispatch(setVehicleProperty(vehicleId, propertyName, propertyValue, callback));
    },
    deleteProperty(vehicleId, propertyName) {
      dispatch(deleteVehicleProperty(vehicleId, propertyName));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const RdwDateSellerSoldButton = compose(withConnect, withRouter, injectIntl)(RdwDateSellerSoldButtonComp);
